module.exports = __webpack_public_path__ + "img/xwg2.dc44588e.png";